export default __webpack_public_path__ + "static/media/software_generic.5794a0e9.svg";